import React, {useEffect, useState} from "react";
import {Col} from "react-bootstrap";

// Components
import DroppableDirectCostField from "./Fields/DroppableDirectCostField";

const BottomRightBlockRowField = (props) => {

  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setCanEdit(props.canEdit);
  }, [props.canEdit]);

  const appendContainer = (coins, hasCard, newCardValue, cardColor, oldCardValue, id) => {
    props.appendContainer(props.id, coins, hasCard, newCardValue, cardColor, oldCardValue, id);
  }

  const removeContainer = () => {
    props.removeContainer(props.id);
  }

  const removeCoin = (index, isDropToDelete) => {
    props.removeCoin(props.id, index, isDropToDelete);
  }

  const showContainerProperties = () => {
    props.showContainerProperties(props.id);
  }

  return (
    <Col className="Droppable-container-margin position-relative" onClick={showContainerProperties}>
      <DroppableDirectCostField
        canEdit={canEdit}
        id={props.id}
        data={props.object}
        appendContainer={appendContainer}
        appendDirectCostContainer={props.appendDirectCostContainer}
        removeContainer={removeContainer}
        removeCoin={removeCoin}
        isDraggingHandler={() => {}}
      />
    </Col>
  )
}

export default BottomRightBlockRowField;
